import React from "react";
import cn from "classnames";
import PropTypes from "prop-types";
import withStyles from "components/with-styles";
import styles from "./styles/static-icon-radio-button.css.js";
import IconButton from "@material-ui/core/IconButton";

const StaticIconRadioButton = ({ id, classes, selected, onClick, label, srcSelected, srcDeselected, srcDisabled, alt, disabled, ...props }) => {
  const handleClick = () => {
    onClick(id);
  };

  return (
    <IconButton
      id={id}
      component="span"
      onClick={handleClick}
      className={cn(classes.icon_radio_button, { [classes.icon_radio_button__selected]: selected })}
      disabled={disabled}
      {...props}
    >
      <img src={disabled ? srcDisabled : (selected ? srcSelected : srcDeselected)} alt={'tiivii icon'} className={classes.tiivii_icon}/>
      <span className={classes.label}>{label}</span>
    </IconButton>
  );
};

StaticIconRadioButton.propTypes = {
  /**
   * Indica si el radio button está seleccionado
   */
  selected: PropTypes.bool,
  /**
   * Id del radio button
   */
  id: PropTypes.string.isRequired,
  /**
   * Etiqueta del icono
   */
  label: PropTypes.string,
  /**
   * Callback de click
   */
  onClick: PropTypes.func,
};

export default withStyles(styles)(StaticIconRadioButton);
